import BaseModel from "@model/BaseModel";
import { observable } from "mobx";

export default class BranchOffice extends BaseModel {
  @observable name: string;
  @observable company_id: string;
}
